import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectRegions } from 'shared/selectors/regions';
import { fetchCitiesByRegion } from 'shared/services/fetchCitiesByRegion';
import { ISelectCityActionPayload } from 'shared/slices/geo/types';
import { updateRegion } from 'shared/thunks/jsonQuery';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { ILocation } from 'shared/types/location';
import { IThunkApi } from 'shared/types/redux';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const selectCityBySuggest = createAsyncThunk<ISelectCityActionPayload, ILocation, IThunkApiExtended>(
  'geo/locationSwitcher/selectCityBySuggest',
  async (city, { getState, extra: context, rejectWithValue, dispatch }) => {
    const state = getState();
    const regions = selectRegions(state);

    try {
      const result = await fetchCitiesByRegion(context, { regionId: city.parentId as number });

      dispatch(updateRegion(city));
      dispatch(updateSearchMeta());

      return {
        city,
        cities: result,
        selectedRegion: regions.find(r => r.id === city.parentId),
      };
    } catch {
      return rejectWithValue();
    }
  },
);
